import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../services/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DarkModeService } from "../../services/dark-mode.service";

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss'],
  standalone: false
})
export class SetPasswordComponent implements OnInit {
  private fb: FormBuilder = inject(FormBuilder)
  private authService: AuthService = inject(AuthService)
  private notificationService: NotificationService = inject(NotificationService);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);
  private readonly darkModeService: DarkModeService = inject(DarkModeService);

  form: FormGroup;

  loading = false;

  // password
  showPassword: boolean = true;
  showPassword2: boolean = true;

  token: string;

  // Dark Mode State
  public activeLightMode: 'light' | 'night' = 'light';
  public isLightMode: boolean = true;


  constructor() {
  }

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.paramMap.get("token")
    this.form = this.fb.group({
      password: [null, Validators.required],
      confirmPassword: [null, Validators.required],
    });

    // Initialize dark mode state
    this.activeLightMode = this.darkModeService.isDarkMode ? 'night' : 'light';
    this.isLightMode = this.activeLightMode === 'light';
  }

  submitForm(value) {
    if (value.password === value.confirmPassword) {
      let data = {
        userPassword: value.password,
        requestToken: this.token
      }
      this.authService.setPassword(data).then(
        async (response) => {
          if (response.status) {
            await this.router.navigate(['', 'login']);
          }
        }
      )
    }
    else {
      this.notificationService.errorMessage("Passwords do not match");
    }
  }

  /**
   * Toggles between light and dark theme
   */
  public toggleTheme(): void {
    this.activeLightMode = this.isLightMode ? 'light' : 'night';
    this.darkModeService.toggleDarkMode();
  }
}
